import { useMemo } from "react";
import ChartCanvas from "components/ChartCanvas";
import customersService from "services/admin/customersService";
import { formatMonthKey, formatNumber, getMonthKeys, useDashboardQuery } from "../dashboard-utils";
import ChartCard from "./ChartCard";
import { barOptions } from "./chartOptions";

const OPTIONS = barOptions((v) => `${formatNumber(v)} чел.`);

/** Бэкенд отдаёт фиксированные последние 12 месяцев — от общего периода не зависит. */
const NewCustomersByMonth = () => {
  const q = useDashboardQuery(["new-customers-by-month"], async () => (await customersService.getNewCustomersByMonths()).data);

  const { chartData, total } = useMemo(() => {
    const keys = getMonthKeys(11);
    const rows: any[] = Array.isArray(q.data) ? q.data : [];
    const values = keys.map((k) => Number(rows.find((x) => x.month === k)?.sum) || 0);
    return {
      total: values.reduce((a, b) => a + b, 0),
      chartData: {
        labels: keys.map(formatMonthKey),
        datasets: [
          {
            label: "Новые клиенты",
            data: values,
            backgroundColor: "rgba(79, 70, 229, 0.3)",
            hoverBackgroundColor: "rgba(79, 70, 229, 0.55)",
            borderColor: "rgb(79, 70, 229)",
            borderWidth: 1,
            borderRadius: 4,
            maxBarThickness: 48,
          },
        ],
      },
    };
  }, [q.data]);

  return (
    <ChartCard
      title="Новые клиенты по месяцам"
      description={total > 0 ? `Итого: ${formatNumber(total)}` : undefined}
      periodLabel="Последние 12 мес."
      loading={q.isLoading}
      error={q.error}
      onRetry={q.refetch}
      empty={total === 0}
    >
      <ChartCanvas type="bar" data={chartData} options={OPTIONS} height={280} />
    </ChartCard>
  );
};

export default NewCustomersByMonth;
